export const lifeBlueprintUrl = 'https://8e8npnu6cb.execute-api.ap-southeast-2.amazonaws.com/test2/v1/blueprint';